/**
 * 对公支付上传回执入参接口
 */
export interface UploadReceiptParams {
    /** 内部订单ID */
    innerOrderId: string;
    /** 企业名称 */
    userBusinessName: string;
    /** 联系电话 */
    userContactNumber: string;
    /** 上传的文件对象 */
    file: File;
}

/**
 * 对公转账预下单返回值接口
 */
export interface ICorporateTransferOrderInfo {
    /** 中台订单标识；新预下单取 innerOrderId，历史订单取 transactionId。 */
    orderId?: string;
    /** 汇款备注，历史订单在 getGoodInfo 后补全。 */
    corporateId?: string;
}


/**
 * 对公转账申请状态
 * 0-未申请 1-已申请 2-已取消 3-已成功, 4-待审批
 */
export enum CorporateTransferApplyStatus {
    /** 未申请 */
    'NOT_APPLY' = 0,
    /** 已申请,对公支付待确认 */
    'APPLIED' = 1,
    /** 已取消 */
    'CANCELLED' = 2,
    /** 支付成功 */
    'SUCCESS' = 3,
    /** 对公支付待确认 */
    'PENDING' = 4,
}


/**
 * 申请合同返回信息接口
 */
export interface ICreateContractResponse {
    /** 合同文件地址 */
    contractUrl: string;
    /** 合同编号 */
    protocolNumber: string;
    /** 创建时间 */
    createTime: string;
}
